import * as React from "react";
import { makeStyles } from "@fluentui/react-components";

interface ErrorBoxProps {
  show: boolean;
  extraStyles?: React.CSSProperties;
  children: React.ReactNode;
}

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    color: "white",
    backgroundColor: "darkred",
    textAlign: "center",
    border: "1px solid red",
    borderRadius: "0.5rem",
    padding: "0.5rem",
    margin: "0.5rem 0",
  },
});

const ErrorBox: React.FC<ErrorBoxProps> = (_props: ErrorBoxProps) => {
  const styles = useStyles();

  return (
    <>
      {_props.show && (
        <div className={styles.root} style={_props.extraStyles}>
          {_props.children}
        </div>
      )}
    </>
  );
};

export default ErrorBox;
